/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-28 10:04:52
 */
/** ***************************正式环境************************************/
export const API_ROOT = "/api";

/** ****************************测试环境***********************************/
// export const API_ROOT = "";

// 生产环境和测试环境
export const debug = process.env.NODE_ENV !== "production";

// 设置请求的超时时间   单位毫秒
export const REQUEST_TIMEOUT = 30000;

// 文件服务器
export const FILE_ROOT = "http://192.168.0.156:9100/"; //测试环境  7.27修改
// export const FILE_ROOT = "https://api.kylin.dyzdx.com/"; //正式环境

// 一页显示的条目
export const PAGE_SIZE = 10;
export const PAGE_ARRY = [PAGE_SIZE, 15, 20, 25, 30];

// 校验 只允许英文,数字
export const TEST_ENGNUM = /[A-Za-z0-9]$/;

// 在职状态
export const JOB_STATUS = {
	1: "在职",
	2: "退休",
	3: "离职",
	4: "死亡",
};

// 申报状态
export const APPLY_STATUS = {
	1: "申报中",
	2: "待申报",
	3: "申报结束",
};

// 年龄段
export const AGE_GROUP = {
	1: "30岁以下",
	2: "31-40岁",
	3: "41-50岁",
	4: "51岁以上",
};

//common status
export const COMMON_STATUS = [
	{
		key: "0",
		name: "禁用",
	},
	{
		key: "1",
		name: "正常",
	},
];

//支付状态--订单管理--order
export const PAY_STATUS = [
	{
		key: "0",
		name: "待支付",
	},
	// {
	//     key: '3',
	//     name: '取消支付'
	// },
	// {
	//     key: '5',
	//     name: '支付确认中'
	// },
	{
		key: "10",
		name: "支付成功",
	},
	{
		key: "15",
		name: "支付失败",
	},
	{
		key: "20",
		name: "退款中",
	},
	{
		key: "25",
		name: "退款完成",
	},
];
export const PAYMENT_TYPE = [
	{
		type: "GOOGLEPAY",
		name: "googlePay",
	},
	{
		type: "APPLEPAY",
		name: "applepay",
	},
	{
		type: "PAYPAL",
		name: "paypal",
	},
	{
		type: "PAYIN",
		name: "payin",
	},
	{
		type: "USEEPAY",
		name: "useepay",
	},
	{
		type: "CREDITCART",
		name: "CreditCard",
	},
];
export const NEWUSER_ORDER = [
	{
		key: "1",
		name: "一转",
	},
	{
		key: "2",
		name: "二转",
	},
];
export const TIME_TYPE = [
	{
		key: "1",
		name: "下单时间",
	},
	{
		key: "2",
		name: "支付时间",
	},
];
//order payment
export const PAY_STATUS_1 = [
	{
		key: "0",
		name: "待支付",
	},
	{
		key: "10",
		name: "支付成功",
	},
	{
		key: "15",
		name: "支付失败",
	},
	{
		key: "20",
		name: "退款中",
	},
	{
		key: "25",
		name: "退款完成",
	},
];
export const PAY_STATUS_2 = [
	{
		key: "SUCCESS",
		name: "SUCCESS",
	},
	{
		key: "FAILED",
		name: "FAILED",
	},
	{
		key: "PENDING",
		name: "PENDING",
	},
];
export const BIZ_TYPE = [
	{
		key: "10",
		name: "会员订单",
	},
	{
		key: "20",
		name: "测评订单",
	},
	{
		key: "30",
		name: "智能起名",
	},
	{
		key: "40",
		name: "测名订单",
	},
	{
		key: "50",
		name: "公司起名",
	},
	{
		key: "60",
		name: "塔罗订单",
	},
	{
		key: "70",
		name: "冥想订单",
	},
];
export const PAY_TYPE = [
	{
		key: "10",
		name: "支付",
	},
    {
        key: "11",
        name: "续费",
    },
	{
		key: "20",
		name: "退款",
	},
];
export const TIME_TYPE_1 = [
	{
		key: "1",
		name: "创建时间",
	},
	{
		key: "2",
		name: "回调时间",
	},
];

// user
export const PHONE_STATUS = [
	{
		key: "0",
		name: "否",
	},
	{
		key: "1",
		name: "是",
	},
];
export const USER_TIME_TYPE = [
	{
		key: "1",
		name: "注册时间",
	},
];

export const USER_VIP_STATUS = [
	{
		key: "0",
		name: "非会员",
	},
	{
		key: "1",
		name: "会员",
	},
];

/*  */
export const COMPLIANT_TIMETYPE = [
	// {
	//     key: '0',
	//     name: "非会员",
	// },
	{
		key: "1",
		name: "投诉时间",
	},
];
/* 退款管理 */
export const ORDER_REFUND_TIMETYPE = [
	{
		key: "0",
		name: "退款时间",
	},
];
/* 退款状态 */
export const ORDER_REFUND_PAY_STATUS = [
	{
		key: "1",
		name: "退款成功",
	},
	{
		key: "2",
		name: "退款失败",
	},
	{
		key: "3",
		name: "待处理",
	},
	{
		key: "4",
		name: "用户已申请",
	},
];

//会员状态
export const USER_VIP_STATUS_1 = [
	{
		key: "0",
		name: "非会员",
	},
	{
		key: "1",
		name: "会员",
	},
	{
		key: "2",
		name: "已过期",
	},
];
//是否付费测评
export const USER_HAS_PAY_EXAM = [
	{
		key: "0",
		name: "否",
	},
	{
		key: "1",
		name: "是",
	},
];

export const USER_TIME_TYPE_1 = [
	{
		key: "register",
		name: "注册时间",
	},
	{
		key: "vipEnd",
		name: "会员到期时间",
	},		
	{
		key: "subscribe",
		name: "下次订阅时间",
	},
];

export const TEST_ORDER_TIME_TYPE = [
	{
		key: "1",
		name: "创建时间",
	},
	// {
	// 	key: "2",
	// 	name: "支付时间",
	// },
	{
		key: "3",
		name: "下单时间",
	},
	{
		key: "4",
		name: "订阅扣费时间",
	},
];

export const CORRECT_OPTIONS = [
	{ key: 0, name: '错误答案' },
	{ key: 1, name: '正确答案' }
];

export const VIEW_OPTIONS = [
	{ key: 've1', name: '列表形' },
	{ key: 've2', name: '田字形' }
];

export const ANSWER_WAY_OPTIONS = [
	{ key: 'sel1', name: '单选' },
	{ key: 'sel2', name: '多选' },
	{ key: 'gap', name: '填空题' }
];


// 订阅时间类型
export const SUBSCRIPTION_TIME_TYPE = [
	{
		key: "1",
		name: "开始时间"
	},{
		key: "2",
		name: "取消时间"
	}
];

// 性别选项
export const GENDER_OPTIONS = [
	{
		key: "0",
		name: "保密"
	},
	{
		key: "1",
		name: "男"
	},
	{
		key: "2",
		name: "女"
	}
];

